module.exports = __webpack_public_path__ + "img/female-youngadult-hand.fbb3c412.svg";